import _ from 'lodash'
import { Vue, axios, store } from './store'

import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.prototype._ = _

Vue.prototype.$http = axios.create({
    baseURL: process.env.API_ENDPOINT
})

Vue.prototype.$api = axios.create({
    baseURL: '/api'
})

Vue.prototype.$http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Vue.prototype.$http.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.filter('padZero', function (num) {
    return num < 10 ? `0${num}` : num
})

Vue.config.productionTip = false

Vue.use(VueReCaptcha, {
    siteKey: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true
    }
})

export { Vue, store }
